import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../../components/ActionButton';
import { withStyles } from '@material-ui/styles';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { CheckCircleOutline, ErrorOutline } from '@material-ui/icons';

const styles = (theme) => ({
  mainContainer: {
    textAlign: 'center',
    padding: '10px',
  },
  iconSuccess: {
    fontSize: 46,
    marginBottom: 10,
    color: theme.palette.success.dark,
  },
  iconError: {
    fontSize: 46,
    marginBottom: 10,
    color: theme.palette.error.main,
  },
  title: {
    fontWeight: 800,
    fontSize: 22,
    marginBottom: 6,
    color: theme.palette.text.primary,
  },

  subtitle: {
    color: theme.palette.text.secondary,
    marginBottom: 14,
  },
  messagePill: {
    display: 'inline-block',
    padding: '6px 12px',
    borderRadius: 12,
    backgroundColor: 'rgba(0,0,0,0.05)',
    fontWeight: 600,
    fontSize: 14,
    wordBreak: 'break-word',
    maxWidth: 520,
    whiteSpace: 'pre-line',
  },

  progressRow: {
    marginTop: 14,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },

  link: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    textDecoration: 'none',
  },
  linkUnderline: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    textDecoration: 'underline',
  },
});

class LoginResult extends React.Component {
  goBackToForm = (event) => {
    event.preventDefault();
    this.props.onBackButtonPressed();
  };

  componentDidMount() {
    const { path } = this.props.theme;
    if (!this.props.hasError) {
      window.setTimeout(function () {
        window.location.href = '/' + path;
      }, 4000);
    }
  }

  render() {
    const { classes, hasError, message, theme } = this.props;

    const title = hasError ? 'Accesso non riuscito' : 'Accesso effettuato';
    const subtitle = hasError
      ? 'Controlla i dati e riprova.'
      : 'Stai per essere reindirizzato alla home page';

    return (
      <div className={classes.mainContainer}>
        <Box py={3}>
          {hasError ? (
            <ErrorOutline className={classes.iconError} />
          ) : (
            <CheckCircleOutline className={classes.iconSuccess} />
          )}

          <Typography className={classes.title}>{title}</Typography>

          <Typography className={classes.subtitle}>{subtitle}</Typography>

          {message && <div className={classes.messagePill}>{message}</div>}

          {!hasError ? (
            <div className={classes.progressRow}>
              <CircularProgress size={18} />
            </div>
          ) : null}

          <Box mt={2} style={{ textAlign: 'center' }}>
            {hasError ? (
              <ActionButton
                onClick={this.goBackToForm}
                label="Indietro"
                disabled={false}
                grayVersion={true}
              />
            ) : (
              <a href={'/' + theme.path} className={classes.linkUnderline}>
                Vai alla home ora
              </a>
            )}
          </Box>
        </Box>
      </div>
    );
  }
}

LoginResult.propTypes = {
  hasError: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onBackButtonPressed: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoginResult);
